module.exports = __webpack_public_path__ + "static/media/enlil_logo.fdef9845.svg";